export function RequiredAsterisk() {
  return <span className="text-danger">*</span>
}